import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations, formatT } from './translations';

const STORAGE_KEY = 'mytownly_driver_lang';
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'te'; } catch { return 'te'; }
  });

  useEffect(() => {
    document.documentElement.lang = lang === 'te' ? 'te' : 'en';
    document.body.classList.toggle('lang-te', lang === 'te');
    try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* */ }
  }, [lang]);

  const toggleLang = useCallback(() => setLangState((p) => (p === 'en' ? 'te' : 'en')), []);

  const t = useCallback((key, vars) => {
    const parts = key.split('.');
    let node = translations[lang];
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) {
        node = translations.en;
        for (const p2 of parts) node = node?.[p2];
        break;
      }
    }
    return typeof node === 'string' ? formatT(node, vars) : key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
